module.exports = __webpack_public_path__ + "img/M118.11f12532.jpg";